/* eslint-disable no-unneeded-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import {
  Container,
  TextField,
  Autocomplete,
  FormControl,
  Stack,
  Grid,
  Snackbar,
  Alert,
  Slide,
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
  Checkbox,
  TableCell,
  Paper,
  
} from '@mui/material';
import { Label as Lable2 } from 'reactstrap';
import tableCellClasses from '@mui/material/TableCell';
import styled from '@emotion/styled';
import { Link, useNavigate, useParams } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import moment from 'moment';
import { update } from 'lodash';
import imagepreview from '../media/upload.png';
import NoimageFound from '../media/noimage.jpg';
import './stylemod.css';
import axios from '../axiosConfig';
import '../Numberinput.css';


const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const SwitchContainer = ({ children }) => (
  <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
    {children}
  </Stack>
);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  // backgroundColor: theme.palette.info.main,
  backgroundColor: '#6482AD',
  color: theme.palette.common.white,
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

export default function AddOB() {
  const { id } = useParams();
  const { type } = useParams();
  const isView = type === 'View';
  const classes = useStyles();
  const navigate = useNavigate();
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  // OPERATIONAL REQUIREMNETS STATES
  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [allRecordsData, setallRecordsData] = useState([]);
  const [buyerSelected, setbuyerSelected] = React.useState('');
  const [BuyerData, setBuyerData] = useState([]);
  const [garmentsData, setGarmentsData] = useState([]);
  const [garmentSelected, setGarmentSelected] = React.useState('');
  const [styleDesc, setStyleDesc] = React.useState('');
  const [styleNum, setStyleNum] = React.useState('');
  const [orderQty, setOrderQty] = React.useState(0);
  const [dayTarget, setDayTarget] = React.useState(0);
  const [shiftHours, setShiftHours] = React.useState(8);
  const [targetPerHour, setTargetPerHour] = React.useState(0);
  const [workingDays, setWorkingDays] = React.useState(26);
  const [planLineEff, setPlanLineEff] = React.useState('');
  const [machinehandEff, setMachinehandEff] = React.useState('');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = React.useState('');
  const [lineData, setLineData] = useState([]);
  // const [lineSelected, setLineSelected] = React.useState({ Line_id: 0, Line_Name: '' });
  const [finalOperation, setFinalOperation] = React.useState('');
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [cmCost, setCmCost] = React.useState('');
  const [cutting, setcutting] = useState(0);
  const [finishing, setfinishing] = useState(0);
  const [costPerMinute, setcostPerMinute] = useState('');
  const [factoryExpenseData, setfactoryExpenseData] = useState([]);

  const [HeaderandDetailID, setHeaderandDetailID] = useState('');
  // ADD OPRATIONS STATES
  const [opGroupSelected, setOpGroupSelected] = useState({ op_group_name: 'All Groups' });
  const [selectedOperations, setSelectedOperations] = useState([]);
  const [machineTypeCounts, setMachineTypeCounts] = useState([]);
  const [OperationData, setOperationData] = useState([]);
  const [opGroupData, setOpGroupData] = useState([]);
  const [operationDetails, setOperationDetails] = useState([]);
  const [remainingOperations, setRemainingOperations] = useState([]);

  // others
  const [alertType, setAlertType] = useState('success');
  const [alertType1, setAlertType1] = useState('error');
  const [openAlert, setopenAlert] = useState(false);
  const [openAlert1, setopenAlert1] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertMessage1, setAlertMessage1] = useState('Please Select One Image');
  const [openLoader, setOpenLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpenRepeat, setDialogOpenRepeat] = useState(false);
  const [checkRepeat, setCheckRepeat] = useState(false);
  const [machineDetailsOpen, setMachineDetailsOpen] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [targetDay, setTargetDay] = useState(0);
  const [factoryCost, setfactoryCost] = useState(0);
  const [draggedOperationIndex, setDraggedOperationIndex] = useState(null);
  const [isDraggingOperation, setIsDraggingOperation] = useState(false);
  const [movedOperationIndex, setMovedOperationIndex] = useState(null);
  const autocompleteRefs = useRef([]);
  // If the header references a Unit that isn't loaded yet, store its id here and reconcile after units load
  const [pendingUnitId, setPendingUnitId] = useState(null);

  const[closeOB, setCloseOB]=useState(false);
  const [deliveryDate, setDeliveryDate] = React.useState('');
  const unitRefs = useRef();
  const refs = {
    buyerSelected: useRef(),
    garmentSelected: useRef(),
    styleDesc: useRef(),
    styleNum: useRef(),
    orderQty: useRef(),
    dayTarget: useRef(),
    shiftHours: useRef(),
    targetPerHour: useRef(),
    workingDays: useRef(),
    planLineEff: useRef(),
    machinehandEff: useRef(),
    finalOperation: useRef(),
    cmCost: useRef(),
  };

  const [fieldErrors, setFieldErrors] = React.useState({
    // opertional requirements
    buyerSelected: false,
    garmentSelected: false,
    styleDesc: false,
    styleNum: false,
    orderQty: false,
    dayTarget: false,
    shiftHours: false,
    targetPerHour: false,
    workingDays: false,
    planLineEff: false,
    machinehandEff: false,
    unitSelected: false,
    // lineSelected: false,
    selectedImageFile: false,
    finalOperation: false,
    cmCost: false,
     deliveryDate: false,
    // cutting: false,
    // finishing: false,
  });

  const resetFields = () => {
    setbuyerSelected(null);
    setGarmentSelected(null);
    setStyleDesc('');
    setStyleNum('');
    setOrderQty('');
    setDayTarget('');
    setShiftHours('');
    setTargetPerHour('');
    setWorkingDays('');
    setPlanLineEff('');
    setMachinehandEff('');
    setUnitSelected('');
    // setLineSelected('');
    setFinalOperation('');
    setCmCost('');
    setcutting('');
    setfinishing('');
    setCloseOB(false);
    setDeliveryDate('');
 
  };

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, selectedImageFile: false }));
    }
  };

  // API Integration
  React.useEffect(() => {
    GetAllFactoryExpenseData();
    GetAllOperationMstData();
    GetAllMachineMstData();
    GetAllActiveBuyers();
    GetAllActiveGarmentMst();
    GetAllActiveOperationGrpData();
    GetAllActiveLineMstData();
    GetAllActiveProductionUnits();
    // console.warn(sessionStorage.getItem('CompanyId'));
  }, []);

  // Effect to update remaining operations when operationDetails or opGroupData changes
  useEffect(() => {
    const getRemainingOperations = () => {
      const addedOperationIds = operationDetails.map((op) => op.OperationId);
      return opGroupData.filter((op) => !addedOperationIds.includes(op.OperationId));
    };
    setRemainingOperations(getRemainingOperations());
  }, [operationDetails, opGroupData]);

  // FOR CALCULATION
  useEffect(() => {
    setTargetDay(
      operationDetails.length > 0
        ? (() => {
            const result = operationDetails.find((currentObject) => currentObject.finalOperation === 'Y');
            return result ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) * shiftHours : 0;
          })()
        : 0
    );
  }, [targetDay, operationDetails]);

  // get all Operation Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperationMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {}, [searchTerm]);

  const filteredData = OperationData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  function formatDate(inputDateTime) {
    const isoDate = new Date(inputDateTime);

    const day = isoDate.getUTCDate().toString().padStart(2, '0');
    const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = isoDate.getUTCFullYear();

    let hour = isoDate.getUTCHours();
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour %= 12;
    hour = hour || 12;

    const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year}`;
  }
  const filteredDataRepeat = allRecordsData.filter((enq) => {
    // console.log(enq, 'searchTermLowerCase');
    const searchTermLowerCase = searchTerm.toLowerCase();

    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // get all Buyers Request
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setBuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllActiveGarmentMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveGarmentMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGarmentsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all group Request
  const GetAllActiveOperationGrpData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationGrpData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpGroupData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine data
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllLineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      // If we had a pending Unit_Id from header load, try to reconcile it now
      if (pendingUnitId && res.data && res.data.length > 0) {
        const found = res.data.find((u) => Number(u.Unit_Id) === Number(pendingUnitId));
        if (found) {
          setUnitSelected(found);
          setPendingUnitId(null);
        }
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };
  const handleCloseAlert1 = () => {
    setopenAlert1(false);
  };

  useEffect(() => {
    if (operationDetails.length !== 0) {
      const machineTotals = {};
      operationDetails.forEach((item) => {
        // console.log(item);
        const machineName = item.Machine_name;
        if (!machineTotals[machineName]) {
          machineTotals[machineName] = { NoofMachines: 0, Count: 0 };
        }
        machineTotals[machineName].NoofMachines += parseFloat(item.NoofMachines);
        machineTotals[machineName].Count += 1; // Counting occurrences
      });

      // Convert the totals object to an array
      const resultArray = Object.keys(machineTotals).map((machineName) => ({
        Machine_name: machineName,
        NoofMachines: machineTotals[machineName].NoofMachines,
        Count: machineTotals[machineName].Count,
      }));
      // console.log(resultArray);
      setMachineTypeCounts(resultArray);
    }
  }, [operationDetails, machineData, id]);

  // pre fill data for editing screen
  useEffect(() => {
    const GetoneObHeader = async (id) => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`GetoneObHeader/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        const data = res.data;
        setHeaderData(res.data[0]);
        data.forEach((editDataonID) => {
          const {
            Buyerid,
            GarmentDescription,
            StyleDescription,
            StyleNumber,
            OrderQty,
            DayTarget,
            ShiftHour,
            Weekdays,
            LineEffecient,
            EstimatedEffecient,
            Batchid,
            Unit_Id,
            OBImage,
            cmCost,
            cutting,
            finishing,
            Factory_Cost,
            ObDate,
            CloseOb,
            DeliveryDate
          } = editDataonID;
          const selectedBuyer = BuyerData.find((obj) => obj.Buyer_Id === Buyerid);
          const selectedGarmentDesc = garmentsData.find((ste) => ste.Garment_Id === GarmentDescription);
          const selectedLine = lineData.find((obj) => obj.Line_id === Batchid); 
          // console.log(Unit_Id, 'Unit_Id');
          const selectedUnit = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          // console.log(selectedUnit, 'dfdf');
          setbuyerSelected(selectedBuyer);
          setGarmentSelected(selectedGarmentDesc);
          setStyleDesc(StyleDescription);
          setStyleNum(StyleNumber);
          setOrderQty(OrderQty);
          setDayTarget(DayTarget);
          setShiftHours(ShiftHour);
          setTargetPerHour(DayTarget / ShiftHour);
          setWorkingDays(Weekdays);
          setPlanLineEff(LineEffecient);
          setMachinehandEff(EstimatedEffecient);
          setCmCost(cmCost);
          setcutting(cutting);
          setfinishing(finishing);
          setfactoryCost(Factory_Cost);
          setCurrentDate(checkRepeat ? new Date() : ObDate);
          // setLineSelected(selectedLine === undefined ? { Line_id: 0 } : selectedLine);
          // If the unit list hasn't loaded yet, remember the id and set a lightweight object so UI doesn't crash
          if (selectedUnit) {
            setUnitSelected(selectedUnit);
          } else if (Unit_Id) {
            setUnitSelected({ Unit_Id });
            setPendingUnitId(Unit_Id);
          } else {
            setUnitSelected({ Unit_Id: 0 });
          }
          setCloseOB(CloseOb === 'Y' ? true : false);
           const formattedDate = moment(DeliveryDate).format('YYYY-MM-DD');
        setDeliveryDate(formattedDate);
          setSelectedImageFile(`${axios.baseURL}OperationBulletin/${OBImage}`);
          setImagePreview(`${axios.baseURL}OperationBulletin/${OBImage}`);
        });
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };
    const fetchAndSetOperations = async (id) => {
      try {
        const response = await axios.instance.get(`GetoneObDetail/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        if (response.data && response.data.length > 0) {
          const receivedData = response.data;
          console.log(response.data, 'details');

          // Map received data to the desired format
          const newAddedOperations = receivedData.map((operation) => {
            return {
              Operationid: operation.Operationid,
              OperationName: operation.OperationName,
              Mctypeid: operation.Mctype,
              Startch1: operation.Startch1,
              Startch2: operation.Startch2,
              Estimatedsmv: operation.Estimatedsmv,
              Actucalsmv: operation.Actucalsmv,
              NoofOperation: operation.NoofOperation,
              NoofMachines: operation.NoofMachines,
              HoursTarget: operation.HoursTarget,
              Daytarget: operation.Daytarget,
              ThirdLength: operation.ThirdLength,
              SPI: operation.Stitch_per_Inch,
              RMP: operation.RMP,
              emp_role: operation.emp_role,
              CreatedBy: sessionStorage.getItem('UserID'),
              threadinch: operation.threadinch,
              Machine_name: operation.Machine_name,
              threadConsumptionFactor: operation.threadConsumptionFactor,
              // Snodtl: operation.Snodtl,
              finalOperation: operation.FinalOperation,
            };
          });

          setOperationDetails(newAddedOperations);
          const selectedFinalOperation = newAddedOperations.find((operation) => operation.finalOperation === 'Y');
          // console.log(selectedFinalOperation);
          setFinalOperation(selectedFinalOperation);
        }
      } catch (error) {
        console.error('Error fetching operations data:', error);
      }
    };

    if (id) {
      GetoneObHeader(id);
      fetchAndSetOperations(id);
    } else {
      GetoneObHeader(HeaderandDetailID);
      fetchAndSetOperations(HeaderandDetailID);
    }
  }, [id, BuyerData, garmentsData, lineData, HeaderandDetailID,unitData]);

  // Updated form validation functions
  const validateOpeartinRequirements = () => {
      const obDate = moment(currentDate).format('YYYY-MM-DD');
      const isDeliveryDateValid = deliveryDate && moment(deliveryDate).isSameOrAfter(obDate, 'day');
    const errors = {
      buyerSelected: !buyerSelected,
      garmentSelected: !garmentSelected,
      styleDesc: !styleDesc,
      styleNum: !styleNum,
      orderQty: !orderQty,
      dayTarget: !dayTarget,
      shiftHours: shiftHours === '' || shiftHours === 0,
      targetPerHour: targetPerHour === '',
      workingDays: workingDays === '',
      planLineEff: planLineEff === '',
      machinehandEff: machinehandEff === '',
      finalOperation: finalOperation === '',
      cmCost: cmCost === '',
      // cutting: cutting === '',
      // finishing: finishing === ''
      //  lineSelected: !lineSelected,
      unitSelected: !unitSelected,
      deliveryDate: !deliveryDate || !isDeliveryDateValid,
      // selectedImageFile: !selectedImageFile,
    };
    console.log(errors, 'errors');
    setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, ...errors }));
    return !Object.values(errors).some(Boolean);
  };

  const handleFormSubmit = () => {
    if (!validateOpeartinRequirements()) {
      const validations = [
        { condition: !buyerSelected, ref: refs.buyerSelected, message: 'Please Select Buyer' },
        { condition: !garmentSelected, ref: refs.garmentSelected, message: 'Please Select Garment' },
        { condition: !styleDesc, ref: refs.styleDesc, message: 'Please Enter Style Description' },
        { condition: !styleNum, ref: refs.styleNum, message: 'Please Enter Style Number' },
        { condition: !orderQty, ref: refs.orderQty, message: 'Please Enter Order Valid Quantity' },
        { condition: !dayTarget, ref: refs.dayTarget, message: 'Please Enter Day Target' },
        { condition: shiftHours === '', ref: refs.shiftHours, message: 'Please Enter Shift Hours' },
        { condition: targetPerHour === '', ref: refs.targetPerHour, message: 'Please Enter Target Per Hour' },
        { condition: workingDays === '', ref: refs.workingDays, message: 'Please Enter Working Days' },
        { condition: planLineEff === '', ref: refs.planLineEff, message: 'Please Enter Planned Line Efficiency' },
        { condition: machinehandEff === '', ref: refs.machinehandEff, message: 'Please Enter Machine Hand Efficiency' },
        { condition: finalOperation === '', ref: refs.finalOperation, message: 'Please Enter Final Operation' },
        { condition: cmCost === '', ref: refs.cmCost, message: 'Please Enter CM Cost' },
        // { condition: cutting === '', ref: refs.cutting, message: 'Please Enter Cutting' },
        // { condition: finishing === '', ref: refs.finishing, message: 'Please Enter Finishing' },
      ];

      for (const { condition, ref, message } of validations) {
        if (condition) {
          // console.log(message, 'message')
          // console.log(openAlert, 'openAlert')
          setAlertType('warning');
          setAlertMessage(message);
          setopenAlert(true);
          ref.current?.focus();
          unitRefs.current?.focus();
          return;
        }
      }
      return;
    }

    const allComplete =
      operationDetails.filter(
        (data) =>
          data.Estimatedsmv === undefined ||
          data.Estimatedsmv === null ||
          data.Estimatedsmv === '' ||
          Number(data.Estimatedsmv) === 0
      ).length === 0;

    if (allComplete) {
      let modifiedUrl;
      const originalUrl = selectedImageFile;
      const baseUrl = `${axios.baseURL}OperationBulletin/`;
      if (typeof originalUrl !== 'object') {
        modifiedUrl = originalUrl.replace(baseUrl, '');
      } else {
        modifiedUrl = selectedImageFile;
      }

      const formData = new FormData();
      formData.append('ObDate', currentDate);
      formData.append('ObNo', 1);
      formData.append('Buyerid', buyerSelected.Buyer_Id);
      formData.append('StyleDescription', styleDesc);
      formData.append('StyleNumber', styleNum);
      formData.append('GarmentDescription', garmentSelected.Garment_Id);
      formData.append('Batchid', 0);
      formData.append('Unit_Id', unitSelected.Unit_Id);
      formData.append('DayTarget', dayTarget);
      formData.append('ShiftHour', shiftHours);
      formData.append('Weekdays', workingDays);
      formData.append('LineEffecient', planLineEff);
      formData.append('EstimatedEffecient', machinehandEff);
      formData.append('OrderQty', orderQty);
      formData.append('OBImage', modifiedUrl);
      formData.append('CreatedBy', sessionStorage.getItem('UserID'));
      formData.append('CompanyId', sessionStorage.getItem('CompanyId'));
      formData.append('FiscalYear', sessionStorage.getItem('FiscalYear'));
      formData.append('cmCost', cmCost);
      formData.append('cutting', cutting === '' ? 0 : cutting);
      formData.append('finishing', finishing === '' ? 0 : finishing);
      formData.append('CloseOb', closeOB ? 'Y' : 'N');
      formData.append('DeliveryDate', deliveryDate);
      // formData.append('Projected_Cost', totalCost.toFixed(3));

      if (!id) {
        formData.append('Factory_Cost', costPerMinute.toFixed(3));
        addNewOB(formData);
      } else {
        formData.append('Factory_Cost', factoryCost);

        updateOB(id, formData);
      }
    } else {
      // alert('Please select Operator');
      setAlertType('warning');
      setAlertMessage('Please enter Needle down time');
      setopenAlert(true);
      for (let i = 0; i < operationDetails.length; i += 1) {
        if (
          operationDetails[i].Estimatedsmv === undefined ||
          operationDetails[i].Estimatedsmv === null ||
          operationDetails[i].Estimatedsmv === '' ||
          Number(operationDetails[i].Estimatedsmv) === 0
        ) {
          const inputElement = autocompleteRefs.current[i]?.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            // setTimeout(() => {
            //   setopenAlert(false);
            // }, 2000);
            break;
          }
        }
      }
    }
  };

  const addNewOB = (newData) => {
    setOpenLoader(true);

    return axios.instance
      .post('/InsertObHeader', newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Obheaderid !== undefined) {
          const Obheaderid = headerRes.data[0].Obheaderid;

          const detailPromises = operationDetails.map((obj, index) => {
            const insertData = {
              ...obj,
              Obheaderid,
              Snodtl: index + 1,
              FinalOperation: obj.finalOperation,
              ThirdLength: (obj.threadConsumptionFactor * obj.Startch1).toFixed(2),
            };

            // console.log('InsertObDetail obj', insertData);

            return axios.instance.post('/InsertObDetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Added Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/operation_bulletin');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error adding detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to add detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed')); // Ensure a consistent return value
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error); // Ensure a consistent return value
      });
  };

  // put Request to edit record
  const updateOB = async (id, newData) => {
    setOpenLoader(true);

    return axios.instance
      .put(`/UpdateObHeader/${id}`, newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Obheaderid !== undefined) {
          const Obheaderid = id;

          const detailPromises = operationDetails.map((obj, index) => {
            const insertData = {
              ...obj,
              Obheaderid,
              Snodtl: index + 1,
              FinalOperation: obj.finalOperation,
              ThirdLength: (obj.threadConsumptionFactor * obj.Startch1).toFixed(2),
            };

            // console.log('InsertObDetail obj', insertData);

            return axios.instance.post('/InsertObDetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });
          console.log(detailPromises, 'detailPromises');
          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Updated Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/operation_bulletin');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error updating detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to Updated detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed'));
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  const getAllOBRecords = async () => {
    setOpenLoader(true);
    try {
      // Convert fromDate and toDate strings to Date objects

      const res = await axios.instance.post(
        '/getAllObBydateFilter',
        {
          FromDate: '0',
          ToDate: '0',
        },
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
      setallRecordsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const GetAllFactoryExpenseData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllFactoryExpenseData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // setfactoryExpenseData(res.data);
      // Calculate the sum of CostPerMinute
      // const totalCostPerMinute = res.data.reduce((sum, item) => {
      //   return sum + (parseFloat(item.CostPerMinute) || 0);
      // }, 0);
      const data = res.data;
    setfactoryExpenseData(data);

    const now = new Date();
    const currentYear = now.getFullYear().toString();   // "2026"
    const currentMonth = (now.getMonth() + 1).toString(); // "1", "2", ...

    let filteredData = [];

    // 1️⃣ Current year + current month
    filteredData = data.filter(
      d => d.YEAR === currentYear && d.Month === currentMonth
    );

    // 2️⃣ Current year + latest month
    if (filteredData.length === 0) {
      const currentYearData = data.filter(d => d.YEAR === currentYear);

      if (currentYearData.length > 0) {
        const latestMonth = Math.max(
          ...currentYearData.map(d => Number(d.Month))
        ).toString();

        filteredData = currentYearData.filter(
          d => d.Month === latestMonth
        );
      }
    }

    // 3️⃣ Previous year + latest month
    if (filteredData.length === 0) {
      const years = [...new Set(data.map(d => Number(d.YEAR)))].sort((a, b) => b - a);
      const previousYear = years[0]?.toString(); // latest available year

      const previousYearData = data.filter(d => d.YEAR === previousYear);

      if (previousYearData.length > 0) {
        const latestMonth = Math.max(
          ...previousYearData.map(d => Number(d.Month))
        ).toString();

        filteredData = previousYearData.filter(
          d => d.Month === latestMonth
        );
      }
    }

    // 🔢 Final Sum
    const totalCostPerMinute = filteredData.reduce(
      (sum, item) => sum + (parseFloat(item.CostPerMinute) || 0),
      0
    );

      console.log('Total CostPerMinute:', totalCostPerMinute);
      setcostPerMinute(totalCostPerMinute);
      console.log(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // console.log('cutting:', cutting);
  // console.log('finishing:', finishing);
  // console.log('Total SMV:', totalSMV);
  // console.log('costPerMinute:', costPerMinute);

  // Calculatuon for toatl CM Cost
  const totalSMV = operationDetails.reduce((accumulator, currentObject) => {
    return Number(accumulator) + Number(currentObject.Actucalsmv || 0);
  }, 0);
  const totalMinutes = (Number(cutting) || 0) + (Number(finishing) || 0) + totalSMV;
  const totalCost = totalMinutes * (!id ? Number(costPerMinute) || 0 : factoryCost);

  const handleInputChangeMachineSelect = (index, newValue) => {
    handleDetailChange(index, 'Mctypeid', newValue ? newValue.Machine_Id : null);
  };

  const handleCheckboxChange = (operationId) => {
    setSelectedOperations((prevState) =>
      prevState.includes(operationId) ? prevState.filter((id) => id !== operationId) : [...prevState, operationId]
    );
  };

  const GetOneOperations = (operationId) => {
    setHeaderandDetailID(operationId);
    handleDialogCloseRepeat();
  };

  // const filteredOperations =
  //   opGroupSelected.op_group_name === 'All Groups'
  //     ? OperationData
  //     : OperationData.filter((obj) => obj.op_group_name === opGroupSelected.op_group_name);

  const searchTermLowerCase = searchTerm.toLowerCase();

  const filteredOperations = OperationData.filter((obj) => {
    // Check if the operation group name matches or if 'All Groups' is selected
    const matchesGroup =
      opGroupSelected.op_group_name === 'All Groups' || obj.op_group_name === opGroupSelected.op_group_name;

    // Filter based on the search term matching any string field in `allRecordsData`
    const matchesSearchTerm = Object.values(obj).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });

    return matchesGroup && matchesSearchTerm;
  });

  const handleAddOperations = () => {
    const newAddedOperations = OperationData.filter((operation) => selectedOperations.includes(operation.OperationId));

    const newOperationDetails = newAddedOperations.map((operation) => {
      const selectedMachineObj = machineData.find((obj) => obj.Machine_Id === operation.Machine_Id);

      // console.log(operation);
      return {
        Operationid: operation.OperationId,
        OperationName: operation.OperationName,
        Mctypeid: selectedMachineObj ? selectedMachineObj.Machine_Id : null,
        Startch1: 0,
        Startch2: 0,
        Estimatedsmv: 0,
        Actucalsmv: 0,
        NoofOperation: 0,
        NoofMachines: 0,
        HoursTarget: 0,
        Daytarget: 0,
        ThirdLength: 0,
        finalOperation: 'N',
        SPI: selectedMachineObj.Stitch_per_Inch,
        RMP: selectedMachineObj.RMP,
        CreatedBy: sessionStorage.getItem('UserID'),
        emp_role: operation.emp_role,
        Machine_name: operation.Machine_name,
        threadinch: selectedMachineObj.threadinch,
        threadConsumptionFactor: selectedMachineObj.threadConsumptionFactor,
        Snodtl: selectedMachineObj.Snodtl,
      };
    });

    // TO Select the operation in order
    const orderedOperationDetails = newOperationDetails.sort((a, b) => {
      return selectedOperations.indexOf(a.Operationid) - selectedOperations.indexOf(b.Operationid);
    });

    console.log(orderedOperationDetails, 'orderedOperationDetails');

    // console.log('added data', orderedOperationDetails);
    setOperationDetails((prevState) => [...prevState, ...orderedOperationDetails]);
    setSelectedOperations([]);
    setDialogOpen(false);
    setSearchTerm('');
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
    setSelectedOperations([]);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setOpGroupSelected({ op_group_name: 'All Groups' });
  };

  const handleDialogCloseRepeat = () => {
    setDialogOpenRepeat(false);
    // setCheckRepeat(false);
  };

  const handleMachineDetailsOpen = () => {
    setMachineDetailsOpen(true);
  };

  const handleMachineDetailsClose = () => {
    setMachineDetailsOpen(false);
  };

  const handleDetailChangeForStarch = (index, field, value) => {
    const parts = value.split('x');
    const num1 = parseFloat(parts[0]);
    const num2 = parseFloat(parts[1]);

    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  };

  function handleDetailChange(index, field, value) {
    const updatedDetails = [...operationDetails];
    console.log(updatedDetails, 'updatedDetails');
    updatedDetails[index][field] = Number(value);
    setOperationDetails(updatedDetails);

    if (field === 'Startch1' || field === 'Estimatedsmv' || field === 'Startch2') {
      recalculateDependentFields(index);
    }
  }

  function recalculateDependentFields(index) {
    const detail = operationDetails[index];
    const estimatedSMV = parseFloat(detail.Estimatedsmv);

    if (!Number.isNaN(estimatedSMV)) {
      const sumofActucalsmv = estimatedSMV + (estimatedSMV * machinehandEff) / 100;

      UpdateSMV(index, 'Actucalsmv', sumofActucalsmv);
      UpdateHoursTarget(index, 'HoursTarget', (sumofActucalsmv !== 0 ? (60 / sumofActucalsmv) * planLineEff : 0) / 100);
    }
  }

  function recalculateDependentFieldsheader(index, machinehandEff1, planLineEff1) {
    const detail = operationDetails[index];
    const estimatedSMV = parseFloat(detail.Estimatedsmv);

    if (!Number.isNaN(estimatedSMV)) {
      const sumofActucalsmv = estimatedSMV + (estimatedSMV * machinehandEff1) / 100;

      UpdateSMV(index, 'Actucalsmv', sumofActucalsmv);
      UpdateHoursTarget(
        index,
        'HoursTarget',
        (sumofActucalsmv !== 0 ? (60 / sumofActucalsmv) * planLineEff1 : 0) / 100
      );
    }
  }

  function multiplyFromString(index, field, value, SPI, RMP, threadinch) {
    // console.log(typeof value);
    // const parts =    value.split('X');

    // if (parts.length >=2) {
    //   console.error('Invalid format. The input should be in the format "LxQty".');
    //   return;
    // }

    // const num1 = Number(parts[0]);
    // const num2 = Number(parts[1]);

    // if (Number.isNaN(num1) || Number.isNaN(num2)) {
    //   const updatedDetails = [...operationDetails];
    //   updatedDetails[index][field] = 0;
    //   setOperationDetails(updatedDetails);
    // } else {
    //   const updatedDetails = [...operationDetails];
    //   updatedDetails[index][field] = num2;
    //   setOperationDetails(updatedDetails);

    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Number(value);
    setOperationDetails(updatedDetails);
    UpdateEstimated(index, 'Estimatedsmv', (Number(value) * SPI) / RMP);
    UpdateThirdLength(index, 'ThirdLength', Number(value) * Number(Math.ceil(threadinch)));
    // }
  }

  function UpdateEstimated(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Number(value).toFixed(3);
    setOperationDetails(updatedDetails);
    recalculateDependentFields(index);
  }

  function UpdateSMV(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Number(value).toFixed(3);
    setOperationDetails(updatedDetails);
  }

  function UpdateHoursTarget(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Math.floor(Number(value));
    setOperationDetails(updatedDetails);
    UpdateDaytarget(index, 'Daytarget', Math.floor(value) * shiftHours);
  }

  function UpdateDaytarget(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Math.floor(value);
    setOperationDetails(updatedDetails);
    UpdateNoofOperation(index, 'NoofOperation', (value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3));
    UpdateNoofMachines(
      index,
      'NoofMachines',
      // Math.round((dayTarget / Math.floor(value * (planLineEff / 100))).toFixed(3))
      (value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3) < 0.5 &&
        (value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3) > 0
        ? 1
        : Math.round((value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3))
    );
  }

  function UpdateNoofOperation(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  }

  function UpdateNoofMachines(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  }

  function UpdateThirdLength(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  }

  const handleDeleteOperation = (index) => {
    setOperationDetails((prevDetails) => prevDetails.filter((_, i) => i !== index));
  };

  const isRepeatModeWithSelection = checkRepeat && Number(HeaderandDetailID) > 0;

  const handleOperationDragStart = (event, index) => {
    if (!isRepeatModeWithSelection || isView) return;
    // Required for consistent HTML5 drag behavior across browsers.
    event.dataTransfer.setData('text/plain', String(index));
    event.dataTransfer.effectAllowed = 'move';
    setMovedOperationIndex(null);
    setDraggedOperationIndex(index);
    setIsDraggingOperation(true);
  };

  const handleOperationDragOver = (event) => {
    if (!isRepeatModeWithSelection || isView) return;
    event.preventDefault();
  };

  const handleOperationDrop = (dropIndex) => {
    if (!isRepeatModeWithSelection || isView) return;
    if (draggedOperationIndex === null || draggedOperationIndex === dropIndex) {
      setDraggedOperationIndex(null);
      setIsDraggingOperation(false);
      return;
    }

    setOperationDetails((prevDetails) => {
      const reordered = [...prevDetails];
      const [draggedItem] = reordered.splice(draggedOperationIndex, 1);
      reordered.splice(dropIndex, 0, draggedItem);
      return reordered;
    });

    setMovedOperationIndex(dropIndex);
    setDraggedOperationIndex(null);
    setIsDraggingOperation(false);
  };

  const handleOperationDragEnd = () => {
    setDraggedOperationIndex(null);
    setIsDraggingOperation(false);
  };

  return (
    <>
      <Snackbar
        key={alertMessage}
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert1}
        autoHideDuration={3000}
        onClose={handleCloseAlert1}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert1} severity={alertType1} variant="filled" sx={{ width: '100%' }}>
          {alertMessage1}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
        >
          <Box>
            <Link to="/dashboard/manage/operation_bulletin">
              <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
                Back
              </Button>
            </Link>
          </Box>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={1}
            pl={2}
            color="white"
            sx={{
              borderTopLeftRadius: 50,
              borderBottomLeftRadius: 50,
              background: 'linear-gradient(to right, #3498db, #2c3e50)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2}>
              <KeyboardDoubleArrowLeftIcon />
              <Typography variant="h6" color="white" className="font_style1">
                Operation Bulletin
              </Typography>
            </Stack>
          </Typography>
        </Stack>

        <Box sx={{ width: '100%' }}>
          <form onSubmit={handleFormSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', py: 2 }}>
              {type === 'View' && (
                <Button variant="outlined" fullWidth color="error" my={2} sx={{ textTransform: 'uppercase' }}>
                  {/* View-only. No changes allowed */}
                  View-only access. Changes are disabled, except for closing OB
                </Button>
              )}
              <Divider sx={{ mb: 1, mt: 2 }}>
                <Chip label="Operational Requirements" size="small" color="primary" />
              </Divider>
              {!id && (
                <Grid item md={6} className="text-end">
                  <Checkbox
                    checked={checkRepeat}
                    onChange={(e) => {
                      setCheckRepeat(e.target.checked);
                      setDialogOpenRepeat(true);
                      getAllOBRecords();
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={isView}
                  />
                  <Lable2 for="example">Repeat</Lable2>
                </Grid>
              )}
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
                mb={2}
              >
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                >
                  <Box>
                    {id && (
                      <Typography variant="h6" color="#1679AB">
                        OB Number : {headerData.ObNo}
                      </Typography>
                    )}
                  </Box>
                </Stack>
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                >
                  <Box>
                    <Typography variant="h6" color="#1679AB">
                      Date : <span>{formatDate(currentDate)}</span>
                    </Typography>
                  </Box>
                </Stack>
              </Stack>

              <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={isView}
                          options={BuyerData}
                          getOptionLabel={(obj) => (obj ? obj.Buyer_Name : '')}
                          isOptionEqualToValue={((option, value) => option?.Buyer_Id === value?.Buyer_Id) ?? undefined}
                          renderInput={(params) => (
                            <TextField {...params} label="Buyer" required inputRef={refs.buyerSelected} disabled={isView} />
                          )}
                          value={buyerSelected}
                          onChange={(e, newValue) => {
                            setbuyerSelected(newValue);
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              buyerSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.buyerSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            Please select buyer
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={isView}
                          options={garmentsData}
                          getOptionLabel={(deg) => (deg ? deg.Garment_Description : '')}
                          isOptionEqualToValue={
                            ((option, value) => option?.Garment_Id === value?.Garment_Id) ?? undefined
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Garments Description"
                              required
                              inputRef={refs.garmentSelected}
                              disabled={isView}
                            />
                          )}
                          value={garmentSelected}
                          onChange={(e, newValue) => {
                            setGarmentSelected(newValue);
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              garmentSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.garmentSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            Please select your garment description
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Style Description"
                        value={styleDesc}
                        required
                        inputRef={refs.styleDesc}
                        disabled={isView}
                        onChange={(e) => {
                          setStyleDesc(e.target.value);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            styleDesc: !e.target.value,
                          }));
                        }}
                        error={fieldErrors.styleDesc}
                        helperText={fieldErrors.styleDesc && 'enter style description'}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Style Number"
                        value={styleNum}
                        required
                        inputRef={refs.styleNum}
                        disabled={isView}
                        onChange={(e) => {
                          setStyleNum(e.target.value);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            styleNum: !e.target.value,
                          }));
                        }}
                        error={fieldErrors.styleNum}
                        helperText={fieldErrors.styleNum && 'enter style number'}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Order Qty"
                        value={orderQty === 0 ? '' : orderQty}
                        type="number"
                        required
                        inputRef={refs.orderQty}
                        disabled={isView}
                        InputProps={{
                          sx: {
                            '& input[type=number]': {
                              MozAppearance: 'textfield', // Firefox
                            },
                            '& input[type=number]::-webkit-outer-spin-button': {
                              WebkitAppearance: 'none', // Chrome, Safari, Edge
                              margin: 0,
                            },
                            '& input[type=number]::-webkit-inner-spin-button': {
                              WebkitAppearance: 'none', // Chrome, Safari, Edge
                              margin: 0,
                            },
                          },
                        }}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^\d]/g, '');
                          setOrderQty(value);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            orderQty: !value,
                          }));
                        }}
                        error={fieldErrors.orderQty}
                        helperText={fieldErrors.orderQty && 'enter order quantity'}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        size="small"
                        type="number"
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        inputRef={refs.dayTarget}
                        required
                        fullWidth
                        label="Day Target"
                        disabled={isView}
                        value={dayTarget === 0 ? '' : dayTarget}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setDayTarget(numericValue);
                          setTargetPerHour(shiftHours ? Math.ceil(Number(numericValue) / Number(shiftHours)) : '');
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            dayTarget: !numericValue,
                          }));
                          if (operationDetails.length !== 0 && numericValue !== '') {
                            const newdata = operationDetails.map((data, index) => ({
                              ...data,
                              Daytarget: Math.round(Number(data.HoursTarget) * Number(shiftHours)),
                              NoofOperation: (
                                Number(numericValue) / Math.floor(Number(data.HoursTarget) * Number(shiftHours))
                              ).toFixed(3),
                              NoofMachines:
                                Number(numericValue) / Math.floor(Number(data.HoursTarget) * Number(shiftHours)) <
                                  0.5 &&
                                Number(numericValue) / Math.floor(Number(data.HoursTarget) * Number(shiftHours)) > 0
                                  ? 1
                                  : Math.round(
                                      Number(numericValue) / Math.floor(Number(data.HoursTarget) * Number(shiftHours))
                                    ).toFixed(3),
                            }));
                            setOperationDetails(newdata);
                          }
                        }}
                        error={fieldErrors.dayTarget}
                        helperText={fieldErrors.dayTarget && 'enter target per day'}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        size="small"
                        type="number"
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        required
                        fullWidth
                        label="Shift(Hrs)"
                        disabled={isView}
                        value={shiftHours === 0 ? '' : shiftHours}
                        inputRef={refs.shiftHours}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setShiftHours(numericValue);
                          setTargetPerHour(numericValue ? Math.ceil(Number(dayTarget / numericValue).toFixed(3)) : '');
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            shiftHours: !numericValue,
                          }));

                          if (operationDetails.length !== 0 && numericValue !== '') {
                            const newdata = operationDetails.map((data, index) => ({
                              ...data,
                              Daytarget: Math.round(Number(data.HoursTarget) * Number(numericValue)),
                              NoofOperation: (
                                dayTarget / Math.floor(Number(data.HoursTarget) * Number(numericValue))
                              ).toFixed(3),
                              NoofMachines:
                                dayTarget / Math.round(Number(data.HoursTarget) * Number(numericValue)) < 0.5 &&
                                dayTarget / Math.round(Number(data.HoursTarget) * Number(numericValue)) > 0
                                  ? 1
                                  : Math.round(
                                      (dayTarget / Math.round(Number(data.HoursTarget) * Number(numericValue))).toFixed(
                                        3
                                      )
                                    ),
                            }));
                            setOperationDetails(newdata);
                          }
                        }}
                        error={fieldErrors.shiftHours}
                        helperText={fieldErrors.shiftHours && 'enter shift hours'}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        size="small"
                        fullWidth
                        required
                        label="Target/Hour"
                        value={targetPerHour === '' || targetPerHour === 0 ? '' : Math.round(targetPerHour)}
                        // onChange={(e) => {
                        //   setTargetPerHour(e.target.value);
                        //   setFieldErrors((prevFieldErrors) => ({
                        //     ...prevFieldErrors,
                        //     targetPerHour: !e.target.value,
                        //   }));
                        // }}
                        inputRef={refs.targetPerHour}
                        error={fieldErrors.targetPerHour}
                        helperText={fieldErrors.targetPerHour && 'enter target per hour'}
                        readOnly
                        disabled={isView}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        required
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        inputRef={refs.workingDays}
                        label="Working Days"
                        disabled={isView}
                        value={workingDays}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setWorkingDays(numericValue);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            workingDays: !numericValue,
                          }));
                        }}
                        error={fieldErrors.workingDays}
                        helperText={fieldErrors.workingDays && 'enter working days'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        inputRef={refs.planLineEff}
                        required
                        label="Plan Line Efficiency(%)"
                        disabled={isView}
                        value={planLineEff}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setPlanLineEff(numericValue);

                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            planLineEff: !numericValue,
                          }));
                          if (operationDetails.length !== 0 && numericValue !== '') {
                            operationDetails.forEach((data, index) => {
                              recalculateDependentFieldsheader(index, Number(machinehandEff), Number(numericValue));
                            });
                          }
                        }}
                        error={fieldErrors.planLineEff}
                        helperText={fieldErrors.planLineEff && 'Enter plan line efficiency(%)'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        required
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        inputRef={refs.machinehandEff}
                        label="Machine + Handling(%)"
                        disabled={isView}
                        value={machinehandEff}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setMachinehandEff(numericValue);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            machinehandEff: !numericValue,
                          }));
                          if (operationDetails.length !== 0 && numericValue !== '') {
                            operationDetails.forEach((data, index) => {
                              recalculateDependentFieldsheader(index, Number(numericValue), Number(planLineEff));
                            });
                          }
                        }}
                        error={fieldErrors.machinehandEff}
                        helperText={fieldErrors.machinehandEff && 'enter machine + handling(%)'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        required
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        label="CM Cost"
                        disabled={isView}
                        value={cmCost}
                        inputRef={refs.cmCost}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setCmCost(numericValue);
                          setFieldErrors((prevFieldErrors) => ({
                            ...prevFieldErrors,
                            cmCost: !numericValue,
                          }));
                        }}
                        error={fieldErrors.cmCost}
                        helperText={fieldErrors.cmCost && 'enter CM Cost'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={isView}
                          options={unitData}
                          getOptionLabel={(obj) => (obj ? obj.Unit_Name : '')}
                          isOptionEqualToValue={((option, value) => option?.Unit_Id === value?.Unit_Id) ?? undefined}
                          renderInput={(params) => (
                            <TextField {...params} label="Factory Unit" required inputRef={unitRefs} disabled={isView} />
                          )}
                          value={unitSelected || null}
                          disableClearable
                          onChange={(e, newValue) => {
                            setUnitSelected(newValue);
                            // GetAllActiveLineMstData(newValue.Unit_Id);
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              unitSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.unitSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            Please select production unit
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>

                    {/* <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset">
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={lineData}
                          getOptionLabel={(obj) => (obj ? obj.Line_Name : '')}
                          isOptionEqualToValue={((option, value) => option?.Line_id === value?.Line_id) ?? undefined}
                          renderInput={(params) => <TextField {...params} label="Batch or Line" />}
                          value={lineSelected}
                          onChange={(e, newValue) => {
                            if (newValue === null) {
                              setLineSelected({ Line_id: 0, Line_Name: '' });
                            } else {
                              setLineSelected(newValue);
                            }
                          }}
                        />
                      </FormControl>
                    </Grid> */}
                    {/* Cutting */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        // required
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        label="Cutting SMV"
                        value={cutting}
                        inputRef={refs.cutting}
                        disabled={isView}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setcutting(numericValue);
                          // setFieldErrors((prevFieldErrors) => ({
                          //   ...prevFieldErrors,
                          //   cutting: !e.target.value,
                          // }));
                        }}
                        // error={fieldErrors.cutting}
                        // helperText={fieldErrors.cutting && 'enter Cutting'}
                      />
                    </Grid>
                    {/* Finishing */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        type="number"
                        // required
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        fullWidth
                        label="Finishing SMV"
                        value={finishing}
                        inputRef={refs.finishing}
                        disabled={isView}
                        onKeyPress={(e) => {
                          // Allow only numbers and control keys
                          if (
                            !/[\d]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^\d]/g, '');
                          setfinishing(numericValue);
                          // setFieldErrors((prevFieldErrors) => ({
                          //   ...prevFieldErrors,
                          //   finishing: !e.target.value,
                          // }));
                        }}
                        // error={fieldErrors.finishing}
                        // helperText={fieldErrors.finishing && 'enter Finishing '}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                 <TextField
  size="small"
  fullWidth
  label="Delivery Date"
  type="date"
  disabled={isView}
  value={deliveryDate}
  InputLabelProps={{
    shrink: true,
  }}
  error={fieldErrors.deliveryDate}
  helperText={fieldErrors.deliveryDate ? 'Delivery date must be on or after OB date' : ''}
  onChange={(e) => {
    const selectedDate = e.target.value;
    setDeliveryDate(selectedDate);
    
    if (selectedDate) {
      const obDate = moment(currentDate).format('YYYY-MM-DD');
      const isValid = moment(selectedDate).isSameOrAfter(obDate, 'day');
      setFieldErrors((prevFieldErrors) => ({
        ...prevFieldErrors,
        deliveryDate: !isValid,
      }));
    } else {
      setFieldErrors((prevFieldErrors) => ({
        ...prevFieldErrors,
        deliveryDate: true,
      }));
    }
  }}
  required
/>
                  </Grid>
                    <Grid item xs={12} md={4}>
                     <SwitchContainer>
                    <input
                      id={`manufacturerb`}
                      className="checkboxfilter"
                      type="checkbox"
                      checked={closeOB}
                      onClick={(e) => {
                        // const newValue = !overall;
                        setCloseOB(!closeOB);
                      }}
                    />{' '}
                   
                       <Lable2
                      htmlFor='manufacturerb'
                      className=" font_stylechecklable text-dark-emphasis"
                      style={{ color: '#468585' }}
                    >
                      Close OB
                    </Lable2>
                  </SwitchContainer>
              
                                            
                  </Grid>
                    
                  </Grid>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Stack direction={'column'} spacing={2}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        border={1}
                        borderRadius={1}
                        borderColor="#e0e0e0"
                        p={1}
                        justifyContent="center"
                      >
                        <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                          <Box>
                            <label htmlFor="fileInput">
                              <img
                                src={
                                  selectedImageFile === `${axios.baseURL}OperationBulletin/`
                                    ? NoimageFound
                                    : selectedImageFile === null || selectedImageFile === '' || !selectedImageFile
                                    ? imagepreview
                                    : imagePreview
                                }
                                // src={!selectedImageFile ? imagepreview : imagePreview}
                                alt="imgfor"
                                className={classes.chooseFileButton}
                                style={{ maxWidth: '200px', maxHeight: '189px', objectFit: 'contain' }}
                              />
                              <input
                                className={classes.fileInput}
                                id="fileInput"
                                type="file"
                                onChange={(event) => {
                                  handleFileChange(event, 'photo');
                                }}
                                style={{ display: 'none' }}
                              />
                            </label>
                          </Box>
                        </Stack>
                      </Stack>
                    </Stack>
                    {fieldErrors.selectedFilePan && (
                      <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                        Please attach the photo
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>

        <Divider sx={{ mb: 1 }}>
          <Chip label="Operations" size="small" color="primary" />
        </Divider>

        <Stack justifyContent={'space-between'} alignItems={'center'} direction={'row'} spacing={2} fullWidth mb={2}>
          <FormControl size="small" sx={{ minWidth: '300px' }} component="fieldset" required>
            <Autocomplete
              size="small"
              fullWidth
              disabled={isView}
              options={operationDetails}
              getOptionLabel={(obj) => (obj ? obj.OperationName : '')}
              isOptionEqualToValue={((option, value) => option?.Operationid === value?.Operationid) ?? undefined}
              renderInput={(params) => (
                <TextField {...params} label="Final Operation" required inputRef={refs.finalOperation} disabled={isView} />
              )}
              value={finalOperation}
              disableClearable
              onChange={(e, newValue) => {
                if (newValue) {
                  setFinalOperation(newValue);
                  setOperationDetails((prevState) =>
                    prevState.map((operation) =>
                      operation.Operationid === newValue.Operationid
                        ? { ...operation, finalOperation: 'Y' }
                        : { ...operation, finalOperation: 'N' }
                    )
                  );
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    finalOperation: !newValue,
                  }));
                } else {
                  setFinalOperation({ OperationName: '', Operationid: 0 });
                }
              }}
            />
            {fieldErrors.finalOperation && (
              <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                Please select final operation
              </Typography>
            )}
          </FormControl>
          <Button variant="outlined" color="primary" 
          disabled={isView}
          onClick={handleDialogOpen}>
            Add Operations
          </Button>
        </Stack>

        {operationDetails.length > 0 && (
          <TableContainer
            component={Paper}
            elevation={5}
            sx={{
              maxHeight: 600,
              borderRadius: 1,
              backgroundColor: 'inherit',
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {isRepeatModeWithSelection && <StyledTableHeader align="center">Drag</StyledTableHeader>}
                  <StyledTableHeader align="center">S.No</StyledTableHeader>
                  <StyledTableHeader align="left">Operation</StyledTableHeader>
                  <StyledTableHeader colSpan={2} align="center">
                    M/C Type
                  </StyledTableHeader>
                  {/* <StyledTableHeader align="center">Stitch Length (in)</StyledTableHeader> */}
                  <StyledTableHeader align="center">Seam Length (cm)</StyledTableHeader>
                  <StyledTableHeader align="center">Needle Down Time</StyledTableHeader>
                  <StyledTableHeader align="center">Planned SMV</StyledTableHeader>
                  <StyledTableHeader align="center">Hourly Target</StyledTableHeader>
                  <StyledTableHeader align="center">Day Target</StyledTableHeader>
                  <StyledTableHeader align="center">No of Operators</StyledTableHeader>
                  <StyledTableHeader align="center">No of Machines</StyledTableHeader>
                  <StyledTableHeader align="center">Thread Required</StyledTableHeader>
                  <StyledTableHeader align="center">Actions</StyledTableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {operationDetails.map((obj, index) => (
                  <TableRow
                    key={index}
                    hover
                    draggable={isRepeatModeWithSelection && !isView}
                    onDragStart={(event) => handleOperationDragStart(event, index)}
                    onDragOver={handleOperationDragOver}
                    onDrop={() => handleOperationDrop(index)}
                    onDragEnd={handleOperationDragEnd}
                    sx={{
                      backgroundColor:
                        draggedOperationIndex === index && isDraggingOperation
                          ? '#FFE4B5'
                          : movedOperationIndex === index
                          ? '#D1FAE5'
                          : obj.finalOperation === 'Y'
                          ? '#EEF5FF'
                          : 'inherit',
                      '& td': {
                        backgroundColor:
                          draggedOperationIndex === index && isDraggingOperation
                            ? '#FFE4B5 !important'
                            : movedOperationIndex === index
                            ? '#D1FAE5 !important'
                            : undefined,
                      },
                      opacity: draggedOperationIndex === index && isDraggingOperation ? 0.75 : 1,
                      cursor: isRepeatModeWithSelection && !isView ? 'move' : 'default',
                    }}
                  >
                    {isRepeatModeWithSelection && (
                      <TableCell align="center" sx={{ width: 40, color: 'text.secondary' }}>
                        <DragIndicatorIcon fontSize="small" />
                      </TableCell>
                    )}
                    <TableCell align="center">{index + 1}</TableCell>

                    <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                      {obj.finalOperation === 'Y' ? (
                        <>
                          {obj.OperationName} <br />
                          <Chip
                            label="final"
                            size="small"
                            color="primary"
                            sx={{ p: 0, m: 0, fontSize: 'x-small', height: 'inherit' }}
                          />
                        </>
                      ) : (
                        obj.OperationName
                      )}
                    </TableCell>

                    <TableCell align="center" colSpan={2} style={{ minWidth: '200px' }}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        disabled={isView}
                        name="group"
                        options={machineData}
                        getOptionLabel={(obj) => (obj ? obj.MachineType : '')}
                        value={
                          machineData.find(
                            (machine) => Number(machine.Machine_Id) === Number(operationDetails[index].Mctypeid)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          handleInputChangeMachineSelect(index, newValue);
                        }}
                        renderInput={(params) => <TextField {...params} label="" disabled={isView} />}
                      />
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: '120px' }}>
                      <TextField
                        size="small"
                        fullWidth
                        id={`Startch${index}`}
                        type="number"
                        disabled={isView}
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        value={operationDetails[index].Startch1}
                        onChange={(e) => {
                          handleDetailChange(index, 'Startch1', e.target.value);
                          multiplyFromString(
                            index,
                            'Startch2',
                            e.target.value,
                            operationDetails[index].SPI,
                            operationDetails[index].RMP,
                            operationDetails[index].threadinch
                          );
                        }}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                            document.getElementById(`Startch${index + 1}`).focus();
                          }
                        }}
                      />
                    </TableCell>

                    <TableCell align="center" style={{ minWidth: '120px' }}>
                      <TextField
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        id={`Estimatedsmv${index}`}
                        size="small"
                        fullWidth
                        type="number"
                        disabled={isView}
                        InputProps={{
                          sx: {
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          },
                        }}
                        ref={(el) => {
                          autocompleteRefs.current[index] = el;
                        }}
                        value={operationDetails[index].Estimatedsmv}
                        onChange={(e) => handleDetailChange(index, 'Estimatedsmv', e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                            document.getElementById(`Estimatedsmv${index + 1}`).focus();
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell align="center"> {operationDetails[index].Actucalsmv}</TableCell>
                    <TableCell align="center"> {operationDetails[index].HoursTarget}</TableCell>
                    <TableCell align="center"> {operationDetails[index].Daytarget}</TableCell>
                    <TableCell align="center">{operationDetails[index].NoofOperation}</TableCell>
                    <TableCell align="center">{operationDetails[index].NoofMachines}</TableCell>
                    <TableCell align="center">
                      {' '}
                      {/* old */}
                      {/* {Math.ceil(operationDetails[index].threadinch * operationDetails[index].Startch1)} */}
                      {/* new  */}
                      {/* {Math.ceil(operationDetails[index].threadConsumptionFactor * operationDetails[index].Startch1)} */}
                      {(operationDetails[index].threadConsumptionFactor * operationDetails[index].Startch1).toFixed(2)}
                    </TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <IconButton aria-label="Delete" onClick={() => handleDeleteOperation(index)} disabled={isView}>
                        <DeleteForeverIcon color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Divider sx={{ my: 2 }}>
          <Chip label="Summary" size="small" color="primary" />
        </Divider>
        <Stack justifyContent={'center'} alignItems={'end'} spacing={2} fullWidth mb={1}>
          <Button
            variant="outlined"
            color="inherit"
            size="small"
            onClick={handleMachineDetailsOpen}
            startIcon={<InfoIcon />}
          >
            Machine Details
          </Button>
        </Stack>

        <Grid
          container
          justifyContent={'center'}
          alignItems={'center'}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          pt={1}
        >
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Total Man Power
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails.reduce((accumulator, currentObject) => {
                    return Number(accumulator) + Number(currentObject.NoofMachines);
                  }, 0)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Work Days
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {workingDays}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  M/C Required
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .filter((data) => data.emp_role === 'O')
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.NoofMachines);
                    }, 0)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Total Operator
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .filter((data) => data.emp_role === 'O')
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.NoofMachines);
                    }, 0)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Total SMV
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.Actucalsmv);
                    }, 0)
                    .toFixed(3)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Time/Pcs
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {/* {finalOperation.Actucalsmv ? finalOperation.Actucalsmv : 0} */}
                  {(() => {
                    const result = operationDetails.find((currentObject) => currentObject.finalOperation === 'Y');
                    return result ? Number(result.Actucalsmv).toFixed(3) : 0;
                  })()}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Total Helper
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .filter((data) => data.emp_role === 'H')
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.NoofMachines);
                    }, 0)
                    .toFixed(0)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Operator SMV
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .filter((data) => data.emp_role === 'O')
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.Actucalsmv);
                    }, 0)
                    .toFixed(3)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Target/Hour
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {/* {finalOperation.HoursTarget ? finalOperation.HoursTarget : 0} */}
                  {(() => {
                    const result = operationDetails.find((currentObject) => currentObject.finalOperation === 'Y'); 
                    return result ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) : 0;
                  })()}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Shift Hours
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {shiftHours}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Helper SMV
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {operationDetails
                    .filter((data) => data.emp_role === 'H')
                    .reduce((accumulator, currentObject) => {
                      return Number(accumulator) + Number(currentObject.Actucalsmv);
                    }, 0)
                    .toFixed(3)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Target/Day
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {/* {finalOperation.Daytarget ? finalOperation.Daytarget : 0} */}
                  {(() => {
                    const result = operationDetails.find((currentObject) => currentObject.finalOperation === 'Y');
                    return result
                      ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) * shiftHours
                      : 0;
                  })()}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Order Qty
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {orderQty} {'pcs'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Days Required
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {/* {Math.round(
                    orderQty === '' ? 0 : orderQty /
                      ((60 /
                        operationDetails
                          .reduce((accumulator, currentObject) => {
                            return Number(accumulator) + Number(currentObject.Actucalsmv);
                          }, 0)
                          .toFixed(0)) *
                          shiftHours === '' ? 0 : shiftHours )
                  )} */}
                  {targetDay !== 0 ? (orderQty / targetDay).toFixed(3) : 0}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Thread Required (mtrs)
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {/* {(
                    operationDetails
                      .reduce((accumulator, currentObject) => {
                        return (
                          Number(accumulator) + Number(Math.ceil(currentObject.threadinch * currentObject.Startch1))
                        );
                      }, 0)
                      .toFixed(0) / 39.37
                  ).toFixed(3)} */}
                  {(
                    operationDetails
                      .reduce((accumulator, currentObject) => {
                        return (
                          Number(accumulator) +
                          Number((currentObject.threadConsumptionFactor * currentObject.Startch1).toFixed(2))
                        );
                      }, 0)
                      .toFixed(0) / 100
                  ).toFixed(3)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Factory Cost/Minutes
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>
                  {!id ? Number(costPerMinute).toFixed(3) : factoryCost}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Projected Cost/Pcs
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  <span style={{ marginRight: '4px' }}> : </span>

                  {totalCost.toFixed(3)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  {/* lll */}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="#009688">
                  {/* <span style={{ marginRight: '4px' }}> : </span>
                  {orderQty} {'pcs'} */}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', pt: 2 }}>
          {/* {type !== 'View' && ( */}
            <Button onClick={handleFormSubmit} color="primary" endIcon={<CheckCircleIcon />} variant="contained">
              Submit
            </Button>
          {/* )} */}
        </Box>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* REPEAT COLLECTION */}
      <Dialog open={dialogOpenRepeat} onClose={handleDialogCloseRepeat} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations</DialogTitle>
        <DialogContent>
          {/* <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ op_group_name: 'All Groups' }, ...opGroupData]}
                getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                isOptionEqualToValue={(option, value) => option?.OP_group_id === value?.OP_group_id}
                renderInput={(params) => <TextField {...params} label="Operation Group" />}
                value={opGroupSelected}
                onChange={(e, newValue) => {
                  setOpGroupSelected(newValue);
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    setOpGroupSelected: !newValue,
                  }));
                }}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack> */}
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
              {/* {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )} */}
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>OB No</TableCell>
                  <TableCell>OB Date</TableCell>
                  <TableCell>Buyer Name</TableCell>
                  <TableCell>Style Description</TableCell>
                  <TableCell>Style No</TableCell>
                  <TableCell>SMV</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDataRepeat.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.ObNo}</TableCell>
                    <TableCell align="left">{formatDate(obj.ObDate)}</TableCell>
                    <TableCell align="left">{obj.Buyer_Name}</TableCell>
                    <TableCell align="left">{obj.StyleDescription}</TableCell>
                    <TableCell align="left">{obj.StyleNumber}</TableCell>
                    <TableCell align="left">{obj.SMV}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Checkbox
                        // checked={selectedOperations.includes(obj.Obheaderid)}
                        onChange={() => GetOneOperations(obj.Obheaderid)}
                        disabled={isView}
                        disabled={isView}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogCloseRepeat} color="secondary">
            Cancel
          </Button>
          {/* {selectedOperations.length > 0 && (
            <Button onClick={handleAddOperations} color="primary">
              Add Selected
            </Button>
          )} */}
        </DialogActions>
      </Dialog>

      {/* add oprations */}
      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations</DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ op_group_name: 'All Groups' }, ...opGroupData]}
                getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                isOptionEqualToValue={(option, value) => option?.OP_group_id === value?.OP_group_id}
                renderInput={(params) => <TextField {...params} label="Operation Group" />}
                value={opGroupSelected}
                onChange={(e, newValue) => {
                  if (newValue) {
                    setOpGroupSelected(newValue);
                    setFieldErrors((prevFieldErrors) => ({
                      ...prevFieldErrors,
                      setOpGroupSelected: !newValue,
                    }));
                  }
                }}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>Operation</TableCell>
                  <TableCell>Group</TableCell>
                  <TableCell>Machine</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredOperations.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.OperationName}</TableCell>
                    <TableCell align="left">{obj.op_group_name}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="left">{obj.emp_role === 'O' ? 'Operator' : 'Helper'}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Checkbox
                        checked={selectedOperations.includes(obj.OperationId)}
                        onChange={() => handleCheckboxChange(obj.OperationId)}
                        disabled={isView}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          {selectedOperations.length > 0 && (
            <Button onClick={handleAddOperations} color="primary" disabled={isView}>
              Add Selected
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* show machine details */}
      <Dialog open={machineDetailsOpen} onClose={handleMachineDetailsClose} maxWidth="xs" fullWidth>
        <DialogTitle>Machine Details</DialogTitle>
        <DialogContent>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="left">Machine Type</TableCell>
                  <TableCell align="center">Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {machineTypeCounts.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="center">{obj.NoofMachines}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
}
